import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  containerClass?: string;
  darker?: boolean;
}
export const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  id,
  containerClass = 'max-w-4xl mx-auto px-4 sm:px-6 lg:px-8',
  darker = false
}) => {
  return <section id={id} className={`py-20 md:py-32 relative ${darker ? 'bg-night-900' : 'bg-night-800'} ${className}`} data-id="element-329">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className={containerClass} data-id="element-330">
        {children}
      </motion.div>
    </section>;
};